import React from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import { YStack, XStack, Separator } from 'tamagui'
import { Strong } from '@newComponents/Text'
import { Button } from '@newComponents/Button/Button'
import { PresentationItem } from '@newComponents/Presentation/PresentationItem'

import { GuildPresentationsScreenOtherPresentationsSection_guild$key } from './__generated__/GuildPresentationsScreenOtherPresentationsSection_guild.graphql'

export const GuildPresentationsScreenOtherPresentationsSection = ({
  guild,
}: {
  guild: GuildPresentationsScreenOtherPresentationsSection_guild$key
}) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildPresentationsScreenOtherPresentationsSection_guild on Guild
      @refetchable(
        queryName: "GuildPresentationsScreenOtherPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        otherPresentations: presentationsByEventTimeSelection(
          first: $count
          after: $cursor
          timeSelection: OTHER
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "GuildPresentationsScreenOtherPresentationsSection_guild_otherPresentations"
          ) {
          edges {
            node {
              ...PresentationItemNew_presentation
            }

            cursor
          }
        }
      }
    `,
    guild
  )

  if (data.otherPresentations.edges.length === 0) {
    return null
  }

  return (
    <YStack gap='$4'>
      <XStack gap='$4' alignItems='center'>
        <Strong color='$grey8'>Other Presentations</Strong>
        <Separator borderColor='$grey4' />
      </XStack>

      {data.otherPresentations.edges.map((edge) => {
        return (
          <PresentationItem
            key={edge.cursor}
            presentation={edge.node}
            numberOfLines={8}
          />
        )
      })}

      {hasNext && (
        <Button
          secondary
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Button.Text secondary>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Button.Text>
        </Button>
      )}
    </YStack>
  )
}
